export default __webpack_public_path__ + "static/media/Snd_LowerVSlidedown.2e6acca9.mp3";